/* import __COLOCATED_TEMPLATE__ from './prism-numbers-only-input.hbs'; */
import Component from '@ember/component';
import { get } from '@ember/object';
const NOT_A_NUMBER_REGEX = /\D/;

/**
 * NumbersOnlyInput component is an input field that
 * accepts only numerals as valid input. All other input is
 * ignored.
 *
 * @param {Action} onInputAction An action to call when an input is made,
 *                               the event on the input is passed to this action
 * @param {String} inputClass CSS class to style the input element
 * @param {String} fieldId An HTML ID with which to identify the input element
 * @param {String} value An initial value to display in the field
 * @param {String} placeholder Placeholder text to display in the input
 * @param {Number} maxLength The maximum length of the input's value
 */

export default Component.extend({
  savedValue: null,
  didInsertElement() {
    this.set('savedValue', this.value);
  },
  onInput(event) {
    const value = get(event, 'target.value');
    if (value.match(NOT_A_NUMBER_REGEX)) {
      // prevents entry of non-digit
      this.notifyPropertyChange('value');
      // notifyPropertyChange removes the value, so this resets the displayed value in the field
      this.set('value', this.savedValue);
      return;
    }

    // update saved display value & send to parent component
    this.set('savedValue', value);
    this.onInputAction && this.onInputAction(event);
  }
});